module.exports = __webpack_public_path__ + "img/dice-d8.5f5cbde3.svg";